import { render, staticRenderFns } from "./SupplierOrders.vue?vue&type=template&id=23747e08&"
import script from "./SupplierOrders.vue?vue&type=script&lang=js&"
export * from "./SupplierOrders.vue?vue&type=script&lang=js&"
import style0 from "./SupplierOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports